import { User } from '../../proto/tumelo/stewardshipbff/v1/user'

export const sampleIDPUser = (override?: Partial<User>): User =>
  User.fromPartial({
    ...override,
  })
